import { type Common } from './common.js';
import type * as User from './models/user.js';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async findUsers(): Promise<{ analysts: User.User[]; admins: User.User[] }> {
    const url = this.common.constructPath('/analyst/list');
    return await this.common.getJSON(url);
  }
}
